import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "isInline"];
import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export function withCn(WrappedComponent) {
  return function (_ref) {
    var className = _ref.className,
      isInline = _ref.isInline,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement("div", {
      className: cn({
        inline: isInline
      }, className),
      "data-t-id": "ui-enhancers"
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  };
}